package com.essntl.features.proposal.ui.allproposal

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.runtime.*
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.ui.Modifier
import com.essntl.features.proposal.domain.model.ProposalModes
import com.essntl.features.proposal.ui.allproposal.components.AddProposalPopup
import com.essntl.features.proposal.ui.allproposal.components.AllProposalHeader
import com.essntl.features.proposal.ui.allproposal.components.ProposalListColumn
import com.essntl.features.proposal.ui.allproposal.components.SelectRequestPopup
import com.essntl.uikit.components.toggle.TabState
import com.essntl.uikit.components.utils.spacing

@Composable
fun AllProposalScreen(
    isSidePanelOpen: Boolean,
    state: AllProposalState,
    onEvent: (AllProposalEvent) -> Unit,
    onNavigation: (AllProposalNavigation) -> Unit,
    modifier: Modifier = Modifier,
) {
    var isAddProposalPopupOpen by rememberSaveable { mutableStateOf(false) }
    var isSelectRequestPopupOpen by rememberSaveable { mutableStateOf(false) }

    val tabItems = listOf(
        TabState(index = ProposalModes.Designer.index, text = "Designer"),
        TabState(index = ProposalModes.Leads.index, text = "Leads"),
    )

    Column(
        modifier = modifier
            .fillMaxSize(),
    ) {
        AllProposalHeader(
            state = state,
            onNavigation = onNavigation,
            isSidePanelOpen = isSidePanelOpen,
            tabItems = tabItems,
            onFilterOptionsChange = { onEvent(AllProposalEvent.FilterProposal(it)) },
            onAddProposal = {
                onNavigation(AllProposalNavigation.AddProposal)
            },
        )

        Spacer(modifier = Modifier.height(1.spacing))

        ProposalListColumn(
            state = state,
            onEvent = onEvent,
            onNavigation = onNavigation,
            onAddProposal = { onNavigation(AllProposalNavigation.AddProposal) },
            modifier = Modifier
                .weight(1f),
        )

        AddProposalPopup(
            isOpen = isAddProposalPopupOpen,
            onDismissRequest = {
                isAddProposalPopupOpen = false
            },
            onAddProposal = {
                onNavigation(AllProposalNavigation.AddProposal)
            },
            onSelectRequest = {
                isSelectRequestPopupOpen = true
            },
        )

        SelectRequestPopup(
            isOpen = isSelectRequestPopupOpen,
            onDismissRequest = {
                isSelectRequestPopupOpen = false
            },
            onConfirmRequest = { requestId ->
                onNavigation(AllProposalNavigation.AddProposal)
            },
            onArrowBackClick = {
                isAddProposalPopupOpen = true
            },
        )
    }
}